import { EOrderBookType } from "@adapters/features/OrderBook/Presenters/action-interface/OrderBook";
import EqOrderBookRepository from "@adapters/features/OrderBook/Repository/EqOrderBook";
import MFOrderBookRepository from "@adapters/features/OrderBook/Repository/MFOrderBook";
import CoOrderBookRepository from "@adapters/features/OrderBook/Repository/CoOrderBook";
import NFOOrderBookRepository from "@adapters/features/OrderBook/Repository/NFOOrderBook";
import IPOOrderBookRepository from "@adapters/features/OrderBook/Repository/IPOOrderBook";
import OFSOrderBookRepository from "@adapters/features/OrderBook/Repository/OFSOrderBook";
import { accountDetails } from "../../../../../../mainDi/webDi";
export default (function (http) {
    var _a;
    return _a = {},
        _a[EOrderBookType.EQ] = new EqOrderBookRepository(http, accountDetails),
        _a[EOrderBookType.CO] = new CoOrderBookRepository(http, accountDetails),
        _a[EOrderBookType.MF] = new MFOrderBookRepository(http, accountDetails),
        _a[EOrderBookType.NFO] = new NFOOrderBookRepository(http, accountDetails),
        _a[EOrderBookType.IPO] = new IPOOrderBookRepository(http, accountDetails),
        _a[EOrderBookType.OFS] = new OFSOrderBookRepository(http, accountDetails),
        _a;
});
